import paxtv from "./paxtv.jpg"
import solaradio from "./solaradio.jpg"

export const rightSideLinksImages = {
    paxtv,
    solaradio
}